import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  message,
} from "antd";
import { defaultForm, fieldTypes } from "./constants";
import React, { useEffect } from "react";
import "./index.css";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const PreChatCustomizer = (props) => {
  const { handleCancel, widget, submitForm } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    let tempForm = [];
    if (widget?.pre_chat_form_fields) {
      tempForm = [...widget?.pre_chat_form_fields];
    } else {
      tempForm = [...defaultForm];
    }
    form.setFieldsValue({ formList: tempForm });
  }, [widget.id, widget.pre_chat_form_fields]);

  const handleFormSubmit = (values) => {
    let errorOccurred = false;

    values?.formList?.forEach((item) => {
      if (item?.type === "select" || item?.type === "radio") {
        console.log(item?.options?.length);

        if (
          item?.options?.length === 0 ||
          item?.options?.length === undefined ||
          item?.options?.length < 2
        ) {
          message.error(`${item.label} must have at least 2 options!`);
          errorOccurred = true; // Set the flag to indicate an error occurred
          return;
        }
      }
    });
    if (errorOccurred) {
      return; // Exit the function if an error occurred
    }
    const tempForm = values?.formList.map((row) => ({
      ...row,
      name: makeNameSlug(row.label, row?.name),
    }));
    submitForm(tempForm);
  };

  const makeNameSlug = (label, name) => {
    if (name) return name;
    return label.toLowerCase().split(" ").join("_");
  };
  const validateMessage = (rule, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject("PlaceHolder required.");
    }
    return Promise.resolve();
  };
  const validateMessageLabel = (rule, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject("Label required");
    }
    return Promise.resolve();
  };
  return (
    <div className="customizer-wrapper">
      <Form
        form={form}
        name="prechat-customizer"
        autoComplete="off"
        onFinish={handleFormSubmit}
      >
        <Form.List name="formList">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map((field) => {
                  const { name, key, ...restField } = field;
                  return (
                    <React.Fragment key={key}>
                      <Row gutter={[8, 8]}>
                        <Col className="end-margin" span={6}>
                          <Form.Item
                            {...restField}
                            label="Type"
                            name={[name, "type"]}
                            rules={[
                              { required: true, message: "Type required" },
                            ]}
                          >
                            <Select placeholder="Select Type">
                              {fieldTypes.map((row) => (
                                <Option key={row.key} value={row.key}>
                                  {row.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col className="end-margin" span={6}>
                          <Form.Item
                            label="Label"
                            {...restField}
                            name={[name, "label"]}
                            rules={[{ validator: validateMessageLabel }]}
                          >
                            <Input placeholder="Label" />
                          </Form.Item>
                        </Col>
                        <Col className="end-margin" span={8}>
                          <Form.Item
                            {...restField}
                            label="Placeholder"
                            name={[name, "placeholder"]}
                            rules={[{ validator: validateMessage }]}
                          >
                            <Input placeholder="Placeholder" />
                          </Form.Item>
                        </Col>
                        <Col className="end-margin" span={3}>
                          <Form.Item
                            {...restField}
                            initialValue={false}
                            valuePropName="checked"
                            name={[name, "required"]}
                          >
                            <Checkbox>Required?</Checkbox>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            initialValue={false}
                            valuePropName="checked"
                            name={[name, "show"]}
                          >
                            <Checkbox>show?</Checkbox>
                          </Form.Item>
                        </Col>
                        {name > 3 && (
                          <Col span={1}>
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          </Col>
                        )}
                        <Col span={24}>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, curValues) => {
                              return (
                                prevValues?.formList[name]?.type !==
                                curValues?.formList[name]?.type
                              );
                            }}
                          >
                            {({ getFieldValue }) => {
                              const selectedType = getFieldValue([
                                "formList",
                                name,
                                "type",
                              ]);
                              return (
                                ["select", "radio", "check-box"].includes(
                                  selectedType
                                ) && (
                                  <Form.List
                                    name={[name, "options"]}
                                    rules={[
                                      {
                                        validator: async (_, names) => {
                                          if (!names || names.length === 0) {
                                            message.error("Add options!");
                                            return Promise.reject(
                                              new Error(
                                                "Enter atleast 2 options"
                                              )
                                            );
                                          }
                                        },
                                      },
                                    ]}
                                  >
                                    {(optionFields, operation) => {
                                      return (
                                        <>
                                          {optionFields.map(
                                            (OptionValue, optionIndex) => {
                                              return (
                                                <React.Fragment
                                                  key={optionIndex}
                                                >
                                                  <Space
                                                    style={{ display: "flex" }}
                                                    align="baseline"
                                                  >
                                                    <Form.Item
                                                      label="Label"
                                                      name={[
                                                        OptionValue.name,
                                                        "label",
                                                      ]}
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "Label required",
                                                        },
                                                      ]}
                                                    >
                                                      <Input placeholder="Label"></Input>
                                                    </Form.Item>
                                                    <Form.Item
                                                      label="Value"
                                                      name={[
                                                        OptionValue.name,
                                                        "value",
                                                      ]}
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "Value required",
                                                        },
                                                      ]}
                                                    >
                                                      <Input placeholder="value"></Input>
                                                    </Form.Item>
                                                    <MinusCircleOutlined
                                                      onClick={() =>
                                                        operation.remove(
                                                          OptionValue.name
                                                        )
                                                      }
                                                    />
                                                  </Space>
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                          <Form.Item className="end-margin">
                                            <Button
                                              type="dashed"
                                              onClick={() => operation.add()}
                                              icon={<PlusOutlined />}
                                            >
                                              Add Option
                                            </Button>
                                          </Form.Item>
                                        </>
                                      );
                                    }}
                                  </Form.List>
                                )
                              );
                            }}
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider></Divider>
                    </React.Fragment>
                  );
                })}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add field
                  </Button>
                </Form.Item>
              </>
            );
          }}
        </Form.List>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
          <Button onClick={handleCancel} className="ml-2" type="default">
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default React.memo(PreChatCustomizer);
